// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Combos_AjustarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract de POST /so/combos/ajustar (NS 2026-0090, fatia 5).
 *
 * Ajuste manual de pares de uma compra de combo: `credito` (+) ou `debito`
 * (-). O debito nunca leva o disponivel abaixo de 0. Full/Franqueado/Gerente.
 *
 * Idempotencia: `idempotency_key` e opcional. Com ela, repetir o MESMO
 * pedido (mesma compra, direcao e quantidade) devolve o ajuste ja gravado
 * (`replay: true`), sem linha nova; a mesma chave num ajuste diferente
 * recusa. Sem ela, o servidor gera uma e a devolve na resposta — reenvie
 * essa chave para repetir o pedido com seguranca.
 *
 * JSON body:
 * {
 *   "purchase_id": 12,                // so_combo_purchases PK, required
 *   "direction": "credito",           // credito | debito, required
 *   "quantity": 2,                    // pares, >= 1, required
 *   "motivo": "Migracao do combo antigo",  // required, nao vazio
 *   "idempotency_key": "b1f0..."      // opcional, 1-64 de [A-Za-z0-9._:-]
 * }
 */
import { registerContract } from './validate'

export interface Combos_AjustarInput {
purchase_id: number
direction: string
quantity: number
motivo: string
idempotency_key?: string
}

registerContract('Combos_AjustarInput', {
  purchase_id:     { type: 'number',  required: true },
  direction:       { type: 'string',  required: true },
  quantity:        { type: 'number',  required: true },
  motivo:          { type: 'string',  required: true },
  idempotency_key: { type: 'string',  required: false },
})
